import { ExclamationCircleIcon } from '@heroicons/react/outline';
import Tooltip from './tooltips/Tooltip';
import classNames from 'classnames';

const InformationTip = ({ tooltipContent, className }: { tooltipContent: string; className?: string }) => {
  if (!tooltipContent) return null;

  return (
    <Tooltip tooltipContent={tooltipContent} className='bg-gray-300 text-black-100 rounded-md' place='right-end'>
      <ExclamationCircleIcon className={classNames('h-6 w-6 text-gray-600 rotate-180', className)} />
    </Tooltip>
  );
};

export default InformationTip;
